
import { HERO_ACTIONS } from "../Actions/heroActions";
import { positionReducer, statsReducer, inventoryReducer } from "../Reducers/utilsReducer"
import { POSITION_ACTIONS, STATS_ACTIONS, INVENTORY_ACTIONS } from "../Actions/utilsActions";
import { EFFECT_TYPE, ITEM_TYPE, ITEM_TYPE_TO_SLOT, STATS_UPDATE_TYPE} from '../../Helpers/constants';
import { createHero } from "../../Classes/heroFactory";
import { log } from "../../Helpers/logger";

// Start with null initial state - we'll set it when we have the actual hero data
const INITIAL_HERO_STATE = null;

// Reducers
export const heroReducer = (state = INITIAL_HERO_STATE, action) => {
    // SET_HERO is the only action that can run without prior state
    if (action.type === HERO_ACTIONS.SET_HERO) {
        return createHero(action.payload.hero);
    }
    if (!state) {
        return null;
    }
    const { position, stats, inventory } = state;
    switch (action.type) {
        case HERO_ACTIONS.RENAME: {
            return {
                ...state,
                name: action.payload.name,
            }
        }
        case HERO_ACTIONS.GAIN_XP: {
            try {
                const { xp } = action.payload;
                if (typeof xp !== 'number' || isNaN(xp)) {
                    console.error('Invalid XP value:', xp);
                    return state;
                }
                
                const nextXp = Math.max(0, state.xp + xp); // Empêche les valeurs négatives
                
                // Si la valeur n'a pas changé, on retourne l'état actuel
                if (nextXp === state.xp) {
                    return state;
                }
                
                return {
                    ...state,
                    xp: nextXp,
                };
            } catch (error) {
                console.error('Error in HERO_ACTIONS.GAIN_XP:', error);
                return state;
            }
        }
        case HERO_ACTIONS.UPDATE_GOLD: {
            try {
                const { gold } = action.payload;
                if (typeof gold !== 'number' || isNaN(gold)) {
                    console.error('Invalid gold value:', gold);
                    return state;
                }
                
                const nextGold = Math.max(0, state.gold + gold); // Empêche les valeurs négatives
                
                // Si la valeur n'a pas changé, on retourne l'état actuel
                if (nextGold === state.gold) {
                    return state;
                }
                
                return {
                    ...state,
                    gold: nextGold,
                };
            } catch (error) {
                console.error('Error in HERO_ACTIONS.UPDATE_GOLD:', error);
                return state;
            }
        }
        case HERO_ACTIONS.MOVE: {
            log.reducer.log('heroReducer - Action MOVE reçue avec payload:', action.payload);
            const newPosition = positionReducer(position, {
                type: POSITION_ACTIONS.MOVE, 
                payload: action.payload
            });
            
            log.reducer.log('heroReducer - Nouvelle position calculée:', newPosition);
            
            return {
                ...state,
                position: newPosition
            };
        }
        case HERO_ACTIONS.TAKE_DAMAGE: {
            const { amount } = action.payload;
            log.reducer.log('TAKE_DAMAGE - Montant des dégâts:', amount);
            log.reducer.log('TAKE_DAMAGE - Vie avant dégâts:', stats.health);
            
            let statsReducerPayload = [
                ['health', STATS_UPDATE_TYPE.DECREMENT, amount, 0],
            ];
            
            log.reducer.log('TAKE_DAMAGE - Payload pour statsReducer:', statsReducerPayload);

            const newState = {
                ...state,
                stats: statsReducer(stats, {
                    type: STATS_ACTIONS.UPDATE,
                    payload: statsReducerPayload,
                })
            };
            
            log.reducer.log('TAKE_DAMAGE - Nouvelle vie après dégâts:', newState.stats.health);
            return newState;
        }
        case HERO_ACTIONS.CAST_SPELL: {
            const { manaCost } = action.payload;
            
            // Si manaCost est négatif, c'est une régénération de mana
            if (manaCost < 0) {
                return {
                    ...state,
                    stats: statsReducer(stats, {
                        type: STATS_ACTIONS.UPDATE,
                        payload: [
                            ['mana', STATS_UPDATE_TYPE.INCREMENT, -manaCost, stats.maxMana]
                        ]
                    })
                };
            }
            
            // Vérifier que le héros a assez de mana
            if (stats.mana < manaCost) {
                log.reducer.warn('Not enough mana to cast spell');
                return state;
            }
            
            // Consommer le mana
            return {
                ...state,
                stats: statsReducer(stats, {
                    type: STATS_ACTIONS.UPDATE,
                    payload: [
                        ['mana', STATS_UPDATE_TYPE.DECREMENT, manaCost, 0]
                    ]
                })
            };
        }
        case HERO_ACTIONS.CONSUME_MANA: {
            const { amount } = action.payload;
            log.reducer.log('CONSUME_MANA - Montant à consommer:', amount);
            log.reducer.log('CONSUME_MANA - Mana avant consommation:', stats.mana);
            
            // Vérifier que le héros a assez de mana
            if (stats.mana < amount) {
                log.reducer.warn('Not enough mana');
                return state;
            }
            
            // Créer le payload pour la mise à jour du mana
            const manaPayload = [
                ['mana', STATS_UPDATE_TYPE.DECREMENT, amount, 0]
            ];
            
            log.reducer.log('CONSUME_MANA - Payload pour statsReducer:', manaPayload);
            
            const newState = {
                ...state,
                stats: statsReducer(stats, {
                    type: STATS_ACTIONS.UPDATE,
                    payload: manaPayload
                })
            };
            
            log.reducer.log('CONSUME_MANA - Nouveau mana après consommation:', newState.stats.mana);
            return newState;
        }
        case HERO_ACTIONS.GAIN_INTELLIGENCE:
        case HERO_ACTIONS.GAIN_STRENGTH: {
            return {
                ...state,
                stats: statsReducer(stats, action),
            }
        }
        case HERO_ACTIONS.LEVEL_UP: {
            const { nextLevel, statsReducerPayload } = action.payload

            return {
                ...state,
                level: nextLevel,
                stats: statsReducer(stats, {
                    type: STATS_ACTIONS.SET,
                    payload: statsReducerPayload,
                }),
            }
        }
        case HERO_ACTIONS.USE_ITEM: {
            const { slotIndex } = action.payload;
            const slot = inventory[slotIndex];
            // log.reducer.log(item);

            if (!slot) {
                // si le slot est égal à null, deja il y a erreur dans le code :
                // s'assurer de donner un slotIndex valide
                return state;
            }
            log.reducer.log('heroReducer', slot);

            switch (slot.item.type) {
                case ITEM_TYPE.POTION: {
                    let statsReducerPayload = [];
                    switch (slot.item.effect.type) {
                        case EFFECT_TYPE.GAIN.HP: {
                            statsReducerPayload = [
                                ...statsReducerPayload,
                                ['health', STATS_UPDATE_TYPE.INCREMENT, slot.item.effect.value, stats['maxHealth']]
                            ];

                            break;
                        }
                        case EFFECT_TYPE.GAIN.MP: {
                            statsReducerPayload = [
                                ...statsReducerPayload,
                                ['mana', STATS_UPDATE_TYPE.INCREMENT, slot.item.effect.value, stats['maxMana']]
                            ];

                            break;
                        }
                        case EFFECT_TYPE.GAIN.HP_MP: {
                            statsReducerPayload = [
                                ...statsReducerPayload,
                                ['health', STATS_UPDATE_TYPE.INCREMENT, slot.item.effect.value, stats['maxHealth']],
                                ['mana', STATS_UPDATE_TYPE.INCREMENT, slot.item.effect.value, stats['maxMana']],
                            ];

                            break;
                        }
                        default:
                            break;
                    }
                    return {
                        ...state,
                        stats: statsReducer(stats, {
                            type: STATS_ACTIONS.UPDATE,
                            payload: statsReducerPayload,
                        }),
                        inventory: inventoryReducer(inventory, {
                            type: INVENTORY_ACTIONS.USE_ITEM_BY_SLOT_INDEX,
                            payload: {
                                slotIndex,
                            },
                        })
                    }
                    
                }
                default:
                    // Cas par défaut pour les actions non gérées
                    return state;
            }
        }
        // break; // Pas nécessaire car on a déjà un return
        
        case HERO_ACTIONS.BUY_ITEM_QUANTITY: {
            const { slotIndex, quantity, idItem, price } = action.payload;
            // log.reducer.log("heroReducer::slotIndex", slotIndex, quantity)
            return {
                ...state,
                gold: state.gold + price,
                inventory: inventoryReducer(inventory, {
                    type: INVENTORY_ACTIONS.ADD_ITEM_QUANTITY_BY_SLOT_INDEX,
                    payload: {
                        slotIndex,
                        quantity,
                        idItem
                    },
                })
            }
        }
        case HERO_ACTIONS.ADD_ITEM_QUANTITY: {
            const { slotIndex, quantity, idItem } = action.payload;
            // log.reducer.log("heroReducer::slotIndex", slotIndex, quantity)
            return {
                ...state,
                inventory: inventoryReducer(inventory, {
                    type: INVENTORY_ACTIONS.ADD_ITEM_QUANTITY_BY_SLOT_INDEX,
                    payload: {
                        slotIndex,
                        quantity,
                        idItem
                    },
                })
            }
        }
        case HERO_ACTIONS.EQUIP_ITEM: {
            // payload.slotKey = 'slot1'..'slot5' from inventory
            const { slotKey } = action.payload;
            const invSlot = inventory?.[slotKey];
            const item = invSlot?.item;
            if (!item) {
                log.reducer.warn('EQUIP_ITEM: empty inventory slot', slotKey);
                return state;
            }
            const slotType = ITEM_TYPE_TO_SLOT[item.type];
            if (!slotType) {
                log.reducer.warn('EQUIP_ITEM: item is not equipable', item);
                return state;
            }
            // Item currently in that equipment slot — swap into the inventory slot.
            const previouslyEquipped = state.equipment?.[slotType] || null;
            return {
                ...state,
                equipment: {
                    ...state.equipment,
                    [slotType]: item,
                },
                inventory: {
                    ...inventory,
                    [slotKey]: previouslyEquipped
                        ? { item: previouslyEquipped, quantity: 1 }
                        : null,
                },
            };
        }
        case HERO_ACTIONS.UNEQUIP_ITEM: {
            // payload.slotType = 'weapon' | 'armor' | 'helm' | 'accessory'
            const { slotType } = action.payload;
            const item = state.equipment?.[slotType];
            if (!item) {
                log.reducer.warn('UNEQUIP_ITEM: nothing equipped in slot', slotType);
                return state;
            }
            // Find the first empty inventory slot.
            const invKeys = Object.keys(inventory || {});
            const emptySlotKey = invKeys.find(k => !inventory[k] || !inventory[k].item);
            if (!emptySlotKey) {
                log.reducer.warn('UNEQUIP_ITEM: inventory is full');
                return state;
            }
            return {
                ...state,
                equipment: {
                    ...state.equipment,
                    [slotType]: null,
                },
                inventory: {
                    ...inventory,
                    [emptySlotKey]: { item, quantity: 1 },
                },
            };
        }
        default:
            // Cas par défaut pour toutes les actions non gérées
            return state;
    }
}